import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const ROLES = {
  SUPER_ADMIN: "super-admin",
  ADMIN: "admin",
  CUSTOMER: "customer",
};

export const PERMISSIONS = {
  ALL: "all",
  MONITORING_DASHBOARD: "monitoring_dashboard",
  CAPACITY_DASHBOARD: "capacity_dashboard",
  BILLING_DASHBOARD: "billing_dashboard",
  COMPUTE_CAPACITY: "compute_capacity",
  GPU_DASHBOARD: "gpu_dashboard",
  GPU_MANAGEMENT: "gpu_management",
  USER_MANAGEMENT: "user_management",
  ORDERS: "orders",
  KNOWLEDGE_MANAGEMENT: "knowledge_management",
  SERVICE_HEALTH_DASHBOARD: "service_health_dashboard",
};

export const ROLE_HAS_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: PERMISSIONS.ALL,
  [ROLES.ADMIN]: [
    PERMISSIONS.MONITORING_DASHBOARD,
    PERMISSIONS.CAPACITY_DASHBOARD,
    PERMISSIONS.BILLING_DASHBOARD,
    PERMISSIONS.ORDERS,
    PERMISSIONS.COMPUTE_CAPACITY,
    PERMISSIONS.GPU_DASHBOARD,
    PERMISSIONS.GPU_MANAGEMENT,
    PERMISSIONS.KNOWLEDGE_MANAGEMENT,
    PERMISSIONS.SERVICE_HEALTH_DASHBOARD,
  ],
  [ROLES.CUSTOMER]: [
    PERMISSIONS.MONITORING_DASHBOARD,
    PERMISSIONS.CAPACITY_DASHBOARD,
    PERMISSIONS.BILLING_DASHBOARD,
    PERMISSIONS.ORDERS,
    PERMISSIONS.COMPUTE_CAPACITY,
    PERMISSIONS.GPU_DASHBOARD,
    PERMISSIONS.GPU_MANAGEMENT,
    PERMISSIONS.KNOWLEDGE_MANAGEMENT,
    PERMISSIONS.SERVICE_HEALTH_DASHBOARD,
  ],
};

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function hasPermission(role, permission) {
  if (!role || !permission) return false;
  return (
    ROLE_HAS_PERMISSIONS[role] === "all" ||
    ROLE_HAS_PERMISSIONS[role].includes(permission)
  );
}

export function getAuth() {
  return JSON.parse(localStorage.getItem("auth"));
}

export function setAuth(data) {
  localStorage.setItem("auth", JSON.stringify(data));
  return true;
}

export function clearAuth() {
  localStorage.removeItem("auth");
  return true;
}

export function openInNewTab(url) {
  return window.open(url, "_blank", "noopener,noreferrer");
}

export function currencyFormatter(amount, currency = "INR") {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function toDateOnly(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
